import { render, staticRenderFns } from "./pure-image.vue?vue&type=template&id=96abf70c&"
import script from "./pure-image.vue?vue&type=script&lang=js&"
export * from "./pure-image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports